import type { AnyFSA } from '@makemydeal/dr-browser-utils';
import type { ReduxStore } from '@makemydeal/dr-shared-store';
import { selectors, fetchCustomerVehicleDealsByCcid, getCheckedInConsumerId } from '@makemydeal/dr-sales-checkin-store';

/**
 * Drops the transient trade-in-modal trigger params once the user has acted on the modal (Apply or
 * Cancel), so a later render or reload doesn't re-open it. Taking dealXgVersion with it is safe:
 * it's only a mirror (bootstrap reads the session copy), and dealVersionSyncMiddleware rewrites it
 * on the next version change.
 */
export const stripTradeInModalUrlParams = () => {
    if (typeof window.location.href !== 'string') return;
    const url = new URL(window.location.href);
    if (!url.searchParams.has('dealXgVersion') && !url.searchParams.has('isShowTradeInModal')) return;
    url.searchParams.delete('dealXgVersion');
    url.searchParams.delete('isShowTradeInModal');
    window.history.replaceState(window.history.state, '', url.toString());
};

/**
 * Re-fetches the customer's deal list (which carries each deal's tradeInVehicles) so a trade-in
 * add/update/remove is reflected in the Deal List slideout without waiting on an unrelated deal
 * save. Shared by every trade-in/deal success action that changes trade-in state.
 */
export const refreshCustomerVehicleDeals = (store: ReduxStore<any>) => {
    const consumerId = getCheckedInConsumerId(store.getState() ?? {});
    if (!consumerId) return;
    const url = new URL(window.location.href);
    const initIsShowTradeInModal = url.searchParams.get('isShowTradeInModal') === 'true';
    if (!initIsShowTradeInModal) store.getState().customerVehicles.isTradeInModalVisible = false;
    store.dispatch(fetchCustomerVehicleDealsByCcid(selectors, consumerId) as unknown as AnyFSA);
};
